import { render } from "./UserCreationPage.vue?vue&type=template&id=2600e026&scoped=true"
import script from "./UserCreationPage.vue?vue&type=script&lang=js"
export * from "./UserCreationPage.vue?vue&type=script&lang=js"

import "./UserCreationPage.vue?vue&type=style&index=0&id=2600e026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2600e026"]])

export default __exports__